const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export interface FormatFileSizeOptions {
  locale?: string;
}

export function formatFileSize(bytes: number, options: FormatFileSizeOptions = {}): string {
  const size = Number.isFinite(bytes) ? Math.max(0, bytes) : 0;
  if (size < 1024) return `${String(Math.round(size))} B`;

  let value = size;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < FILE_SIZE_UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  const maximumFractionDigits = value < 10 ? 1 : 0;
  let formatted: string;
  try {
    formatted = new Intl.NumberFormat(options.locale, { maximumFractionDigits }).format(value);
  } catch {
    formatted = value.toFixed(maximumFractionDigits);
  }

  return `${formatted} ${FILE_SIZE_UNITS[unitIndex] ?? 'B'}`;
}
